var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({attrs:{"render-when-empty":""}},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('div',{staticClass:"cost-text",class:{ 'is-failed': _vm.isFailed }},[_vm._v(_vm._s(_vm.costText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }